export { useGetAllProvisions } from '@dc-shared-web/hooks/api/provision/useGetAllProvisions'
